import moment from 'moment-timezone'
import React from 'react'
import { formatName } from '@paintscout/util/builder'
import Highlight from '@paintscout/ui/components/Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import QuoteLabel from '../QuoteLabel'
import ActivityDot from '../ActivityDot'

export default function QuoteViewedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props

  const diff = activity.details.updated - activity.details.timestamp
  const utc = moment.utc(diff)
  const minutes = Math.trunc(diff / 1000 / 60)
  const viewingEmail = (activity.details as any).viewingEmail as string | undefined
  const viewedBy =
    activity.details?.contact && activity?.details?.contact?.email === viewingEmail
      ? formatName(activity.details.contact)
      : viewingEmail ?? null

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        {showDocTypeDetails ? (
          <>
            {activity.details.quote?.status === 'accepted' && <Highlight>Accepted </Highlight>}
            <QuoteLabel activity={activity} /> was <Highlight>Viewed</Highlight>
          </>
        ) : (
          <>
            <Highlight>Viewed</Highlight>
          </>
        )}{' '}
        for {diff > 10_000 ? `${minutes}m ${utc.format('s')}s` : `less than 10s`}
        {/* We've had some reports of the word 'undefined' showing up in this viewedBy field */}
        <>
          {viewedBy && viewedBy !== 'undefined' && (
            <>
              {' '}
              by <Highlight>{viewedBy}</Highlight>
            </>
          )}
        </>
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
